export default __webpack_public_path__ + "static/media/kakao.9ca741d0.png";